import type { ReactNode } from "react";
import SectionNav from "../components/SectionNav/SectionNav";
import "./MainLayout.css";

type Props = {
  children: ReactNode;
};

function MainLayout({ children }: Props) {
  return (
    <div className="main-layout">
      <SectionNav />
      {children}
    </div>
  );
}

export default MainLayout;